"use client";
import { useEffect, useState } from "react";
import { DiscountModal } from "./discount";
import { AndroidAnnouncementModal } from "./announcement";
import { NotifyMeModal } from "./notify";
import { OrderNowSheet, OsSelectionSheet } from "./order-now";
import { QuizModal } from "./quiz-modal";
import { QuizExitModal } from "./quiz-exit-modal";
import { StartQuizModal } from "./start-quiz-modal";
import { QuizBackdrop } from "./quiz-backdrop";

export const Modals = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <>
      <DiscountModal />
      <AndroidAnnouncementModal />
      <NotifyMeModal />
      <OrderNowSheet />
      <OsSelectionSheet />
      <QuizBackdrop />
      <StartQuizModal />
      <QuizModal />
      <QuizExitModal />
    </>
  );
};
